import React from 'react';
import { fmtDateISO } from '../utils';

export default function DayCell({ day, inMonth, selected, count, dots, onClick }) {
  return (
    <button onClick={onClick} className={`day ${inMonth ? '' : 'dayOut'} ${selected ? 'daySel' : ''}`} title={`${fmtDateISO(day)} • ${count} activities`}>
      <div className="dayTop">
        <span className="dayNum">{day.getDate()}</span>
        {count > 0 ? <span className="dayCount">{count}</span> : <span className="dayCount dayCountZero">·</span>}
      </div>
      <div className="dayDots" aria-hidden>
        {dots.slice(0, 4).map((d, i) => <span key={`${d.t}_${i}`} className="dot" style={{ background: d.c }} />)}
        {dots.length > 4 ? <span className="dotMore">+{dots.length - 4}</span> : null}
      </div>
    </button>
  );
}
